<template>
  <div>
    <t-modal
      v-if="visibleTemplateManager"
      data-testid="premade-templates-modal"
      @close="() => (visibleTemplateManager = false)"
    >
      <template #custom-modal>
        <TemplatesPicker
          @close-templates-picker="closeModal"
          @choose-template="$emit('closeDialog')"
        />
      </template>
    </t-modal>

    <div
      class="group flex cursor-pointer items-center justify-between rounded-md bg-gray-600 p-2 font-inter text-[13px] font-medium text-gray-100 transition duration-300 hover:bg-gray-500 hover:text-gray-50"
      data-testid="premade-templates-button"
      @click="openModla"
    >
      <div class="flex items-center gap-2 leading-6">
        <font-awesome-icon :icon="['fas', 'scroll']" class="w-[20px]" />
        <p>{{ $t("blocks.premade_templates") }}</p>
      </div>

      <t-button>
        <template #icon>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.6387 10.4512C12.8848 10.2051 12.8848 9.79492 12.6387 9.54883L8.91992 5.83008C8.64648 5.55664 8.23633 5.55664 7.99023 5.83008L7.36133 6.43164C7.11523 6.70508 7.11523 7.11523 7.36133 7.36133L10.0137 10.0137L7.36133 12.6387C7.11523 12.8848 7.11523 13.2949 7.36133 13.5684L7.99023 14.1699C8.23633 14.4434 8.64648 14.4434 8.91992 14.1699L12.6387 10.4512Z"
              fill="currentColor"
            />
          </svg>
        </template>
      </t-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import TemplatesPicker from "./TemplatesPicker/TemplatesPicker.vue";
  import { TModal, TButton } from "@topol/twig-ui";
  import { ref } from "vue";

  const visibleTemplateManager = ref(false);

  defineEmits(["closeDialog"]);

  const openModla = () => {
    visibleTemplateManager.value = true;
  };

  const closeModal = () => {
    visibleTemplateManager.value = false;
  };
</script>
